import notifications from "../views/notifications/index.vue";

const routes = [
  {
    path: "/notifications",
    name: "notifications",
    component: notifications,
    meta: { authOnly: true }
  }
];

export default routes;
